export default __webpack_public_path__ + "static/media/crossButton.33c263d2.svg";